// The community challenge calendar's month grid (same rules as the admin's
// features/challenges/calendarShape.js). Pure functions over 'YYYY-MM-DD'
// strings — the API's Europe/Budapest calendar days — so nothing here depends
// on the browser's time zone.

// What a partner can see (D11): everything but cancelled days, which the API
// leaves out. Drafts come flagged as "planned, may change".
export const PARTNER_STATUSES = ['draft', 'scheduled', 'live', 'completed', 'failed'];

export const TIERS = ['normal', 'challenge', 'special'];

const DAY_MS = 86400000;
const pad = (n) => String(n).padStart(2, '0');

function toUtc(date) {
  const [y, m, d] = date.split('-').map(Number);
  return Date.UTC(y, m - 1, d);
}
const fromUtc = (ms) => new Date(ms).toISOString().slice(0, 10);

export const addDays = (date, days) => fromUtc(toUtc(date) + days * DAY_MS);

/** ISO weekday: 1 = Monday … 7 = Sunday. */
export const isoWeekday = (date) => ((new Date(toUtc(date)).getUTCDay() + 6) % 7) + 1;

/** Today in Budapest, until the API answers with its own `today`. */
export function budapestToday(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Budapest',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

export const monthOf = (date) => date.slice(0, 7);

export function shiftMonth(month, delta) {
  const [y, m] = month.split('-').map(Number);
  const d = new Date(Date.UTC(y, m - 1 + delta, 1));
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}`;
}

/** Whole Monday-first weeks around the month: 4–6 rows, at most 42 days. */
export function monthGrid(month) {
  const first = `${month}-01`;
  const last = addDays(`${shiftMonth(month, 1)}-01`, -1);
  const from = addDays(first, 1 - isoWeekday(first));
  const to = addDays(last, 7 - isoWeekday(last));
  const weeks = [];
  for (let day = from; day <= to; day = addDays(day, 7)) {
    const start = day;
    weeks.push(Array.from({ length: 7 }, (_, i) => addDays(start, i)));
  }
  return { from, to, weeks };
}

export function challengeTitle(challenge, lang) {
  const title = challenge && challenge.title;
  if (!title) return null;
  return title[lang] || title[lang === 'hu' ? 'en' : 'hu'] || null;
}

/** "−15%", "−2 000 HUF", or '' for a reward item without a discount. */
export function rewardMagnitude(item, lang) {
  if (item.discount_type === 'percent') return `−${Number(item.discount_value)}%`;
  if (item.discount_type === 'fixed') {
    return `−${Number(item.discount_value).toLocaleString(lang === 'hu' ? 'hu-HU' : 'en-GB')} ${item.currency || ''}`.trim();
  }
  return '';
}
